import type { ChatRoomListResponsePageAllOfThreeContentItemBasicInfo } from './chatRoomListResponsePageAllOfThreeContentItemBasicInfo';
import type { ChatRoomListResponsePageAllOfThreeContentItemLastMessage } from './chatRoomListResponsePageAllOfThreeContentItemLastMessage';
import type { ChatRoomListResponsePageAllOfThreeContentItemParticipantsItem } from './chatRoomListResponsePageAllOfThreeContentItemParticipantsItem';
import type { ChatRoomListResponsePageAllOfThreeContentItemTimeInfo } from './chatRoomListResponsePageAllOfThreeContentItemTimeInfo';

export type ChatRoomListResponsePageAllOfThreeContentItem = {
  basicInfo?: ChatRoomListResponsePageAllOfThreeContentItemBasicInfo;
  /** 마지막 메시지 */
  lastMessage?: ChatRoomListResponsePageAllOfThreeContentItemLastMessage;
  /** 참여자 목록 */
  participants?: ChatRoomListResponsePageAllOfThreeContentItemParticipantsItem[];
  /** 시간 관련 정보 */
  timeInfo?: ChatRoomListResponsePageAllOfThreeContentItemTimeInfo;
};
